import { useEffect } from "react";
import { useCan, useSession } from "../auth/session";
import { voice } from "./manager";

/** Starts the softphone device for users who can place or receive calls, and stops it on sign-out or organization change. */
export function VoiceBootstrap() {
  const { data: session } = useSession();
  const { canAny } = useCan();
  const enabled = !!session && !session.mfaPending && !session.mfaEnrollmentRequired && canAny("calls.initiate", "calls.receive");
  const key = `${session?.membershipId ?? ""}:${enabled}`;
  useEffect(() => {
    if (!enabled) return;
    void voice.start();
    return () => {
      void voice.stop();
    };
  }, [enabled, key]);
  return null;
}
